import React from "react";
import CurrentPlanCard from "./CurrentPlanCard";
import AvailablePlans from "./AvailablePlans";

/**
 * Renders the plans section: the current subscription card and the list of
 * available plans, in either order. All subscription-management actions
 * (cancel, resume, keep-current-plan) are owned by
 * `SubscriptionLifecycleActions`, which the parent renders separately.
 */
const SubscriptionPlansSection = ({
  currentSubscription,
  currentPlan,
  plans,
  showAnnualPricing,
  setShowAnnualPricing,
  onSelectPlan,
  couponUI,
  banner,
  accessGrant,
  upcomingSubscription,
  currentSubscriptionFirst = false,
}) => {
  const availablePlansEl = (
    <AvailablePlans
      plans={plans}
      currentPlan={currentPlan}
      showAnnualPricing={showAnnualPricing}
      setShowAnnualPricing={setShowAnnualPricing}
      onSelectPlan={onSelectPlan}
      couponUI={couponUI}
      banner={banner}
      accessGrant={accessGrant}
    />
  );

  const currentSubscriptionEl = (
    <CurrentPlanCard
      currentSubscription={currentSubscription}
      currentPlan={currentPlan}
      accessGrant={accessGrant}
      upcomingSubscription={upcomingSubscription}
    />
  );

  return (
    <>
      {currentSubscriptionFirst ? currentSubscriptionEl : availablePlansEl}
      {currentSubscriptionFirst ? availablePlansEl : currentSubscriptionEl}
    </>
  );
};

export default SubscriptionPlansSection;
